/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CommunityMetadataCommunityManager } from './';
import {
    CommunityMetadataCommunityManagerFromJSON,
    CommunityMetadataCommunityManagerFromJSONTyped,
    CommunityMetadataCommunityManagerToJSON,
} from './';

/**
 * 
 * @export
 * @interface CommunityMetadata
 */
export interface CommunityMetadata {
    /**
     * 
     * @type {CommunityMetadataCommunityManager}
     * @memberof CommunityMetadata
     */
    communityManager?: CommunityMetadataCommunityManager;
    /**
     * 
     * @type {string}
     * @memberof CommunityMetadata
     */
    engagementStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityMetadata
     */
    onboardingStatus?: string;
}

/**
 * Check if a given object implements the CommunityMetadata interface.
 */
export function instanceOfCommunityMetadata(value: object): value is CommunityMetadata {
    return true;
}

export function CommunityMetadataFromJSON(json: any): CommunityMetadata {
    return CommunityMetadataFromJSONTyped(json, false);
}

export function CommunityMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommunityMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'communityManager': json['communityManager'] == null ? undefined : CommunityMetadataCommunityManagerFromJSON(json['communityManager']),
        'engagementStatus': json['engagementStatus'] == null ? undefined : json['engagementStatus'],
        'onboardingStatus': json['onboardingStatus'] == null ? undefined : json['onboardingStatus'],
    };
}

export function CommunityMetadataToJSON(value?: CommunityMetadata | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'communityManager': CommunityMetadataCommunityManagerToJSON(value['communityManager']),
        'engagementStatus': value['engagementStatus'],
        'onboardingStatus': value['onboardingStatus'],
    };
}

